import type { GuestAccessCommand, GuestAccessRuleDto } from '../api/guestAccessTypes';
import { endpoints } from '../api/sharedEndpoints';

export interface GuestAccessRepository {
  listRules(): Promise<GuestAccessRuleDto[]>;
  listActiveRules(): Promise<GuestAccessRuleDto[]>;
  listBusyResources(startAt: string, endAt: string): Promise<string[]>;
  createRule(command: GuestAccessCommand): Promise<GuestAccessRuleDto>;
  updateRule(id: number, command: GuestAccessCommand): Promise<GuestAccessRuleDto>;
  deleteRule(id: number): Promise<void>;
}

export class ApiGuestAccessRepository implements GuestAccessRepository {
  listRules() {
    return endpoints.getGuestAccessRules();
  }

  listActiveRules() {
    return endpoints.getActiveGuestAccess();
  }

  listBusyResources(startAt: string, endAt: string) {
    return endpoints.getGuestAccessBusyResources(startAt, endAt);
  }

  createRule(command: GuestAccessCommand) {
    return endpoints.createGuestAccessRule(command);
  }

  updateRule(id: number, command: GuestAccessCommand) {
    return endpoints.updateGuestAccessRule(id, command);
  }

  async deleteRule(id: number) {
    await endpoints.deleteGuestAccessRule(id);
  }
}
